import React from "react";
import classNames from "classnames";
import BootstrapTable from "react-bootstrap-table-next";

import { Cut } from "components/Cut";
import { dateFormat, priceFormat } from "utils/format";

import "./analiticsProvider.scss";

export const AnaliticsProviderTable = ({ analiticsProvider, onSort }) => {
  const tableColumns = [
    {
      dataField: "provider",
      text: "Поставщик",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row) => <Cut>{cell}</Cut>,
    },
    {
      dataField: "summ",
      text: "Сумма",
      headerStyle: () => {
        return { width: "20%" };
      },
      formatter: (cell, row) => priceFormat(cell),
      headerClasses: () => "right",
      classes: () => "right bold",
    },
    {
      dataField: "remainingDebt",
      text: "Остаток долга на сегодня",
      headerStyle: () => {
        return { width: "8%" };
      },
      formatter: (cell, row) => priceFormat(cell),
      headerClasses: () => "right",
      classes: (cell) => "right",
      sort: true,
      onSort,
      sortFunc: () => {
        return false;
      },
    },
    {
      dataField: "datePayment",
      text: "Дата оплаты",
      headerStyle: () => {
        return { width: "6%" };
      },
      formatter: (cell, row) => cell ? dateFormat(cell) : "",
      headerClasses: () => "right",
      classes: () => "right",
    },
    {
      dataField: "daysDebtCount",
      text: "Дней до оплаты",
      headerStyle: () => {
        return { width: "6%" };
      },
      formatter: (cell, row) => cell,
      headerClasses: () => "right",
      classes: (cell, row) => classNames("right", {
        red: row.daysDebtCount <= 0,
        green: row.daysDebtCount > 0,
      }),
      sort: true,
      onSort,
      sortFunc: () => {
        return false;
      },
    },
    {
      dataField: "delayDayCount",
      text: "Отсрочка по договору",
      headerStyle: () => {
        return { width: "6%" };
      },
      formatter: (cell, row) => priceFormat(cell),
      headerClasses: () => "right",
      classes: () => "right",
      sort: true,
      onSort,
      sortFunc: () => {
        return false;
      },
    },
    {
      dataField: "payToday",
      text: "Оплатить сегодня",
      headerStyle: () => {
        return { width: "8%" };
      },
      formatter: (cell, row) => priceFormat(cell),
      headerClasses: () => "right",
      classes: (cell) =>
        classNames("right", {
          red: cell > 0,
        }),
      sort: true,
      onSort,
      sortFunc: () => {
        return false;
      },
    },
  ];

  const expandRow = {
    renderer: (row) => {
      return (
        <div className="react-bootstrap-table">
          <table className="table table-hover">
            <tbody>
              {row.supply?.map((val) => (
                <tr key={val.id}>
                  <td style={{ width: "15%" }}></td>
                  <td style={{ width: "5%" }}>№ {val.number}</td>
                  <td style={{ width: "6%" }}>
                    {dateFormat(val.date)}
                  </td>
                  <td style={{ width: "4%" }} className="right">
                    {priceFormat(val.summ)}
                  </td>
                  <td
                    style={{ width: "8%" }}
                    className={classNames("right", {
                      red: val.daysDebtCount <= 0,
                      green: val.daysDebtCount > 0,
                    })}
                  >
                    {priceFormat(parseInt(val.remainingDebt))}
                  </td>
                  <td
                    style={{ width: "6%" }}
                    className={classNames("right", {
                      red: val.daysDebtCount <= 0,
                      green: val.daysDebtCount > 0,
                    })}
                  >
                    {dateFormat(val.paymentDate)}
                  </td>
                  <td style={{ width: "6%" }}
                    className={classNames("right", {
                      red: val.daysDebtCount <= 0,
                      green: val.daysDebtCount > 0,
                    })}>
                    {val.daysDebtCount}
                  </td>
                  <td style={{ width: "6%" }}
                    className={classNames("right", {
                      red: val.daysDebtCount <= 0,
                      green: val.daysDebtCount > 0,
                    })}>
                    {row.delayDayCount}
                  </td>
                  <td
                    style={{ width: "8%" }}
                    className={classNames("right", {
                      red: val.daysDebtCount <= 0,
                      green: val.daysDebtCount > 0,
                    })}
                  >
                    {val.remainingDaysExpired}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    },
  };

  return (
    <>
      <BootstrapTable
        keyField="id"
        data={analiticsProvider}
        columns={tableColumns}
        bootstrap4
        bordered={false}
        hover={true}
        expandRow={expandRow}
      />
    </>
  );
};
